import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";
@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    itemsPerPageLabel: string;
    nextPageLabel: string;
    previousPageLabel: string;

    constructor() {
        super();
        //console.log("shared module");
        this.itemsPerPageLabel = "Ítems por página";
        this.nextPageLabel = "Siguiente";
        this.previousPageLabel = "Anterior";
    }

    getRangeLabel = (page, pageSize, length): string => {
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        const endIndex =
            startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
        return startIndex + 1 + " - " + endIndex + " de  " + length;
    };
}
/*export function CustomPaginator() {
    const customPaginatorIntl = new MatPaginatorIntl();

    customPaginatorIntl.itemsPerPageLabel = "Items por página:";
    customPaginatorIntl.nextPageLabel = "Siguiente";
    customPaginatorIntl.previousPageLabel = "Anterior";
    customPaginatorIntl.getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return "0 de " + length;
        }
        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex =
            startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
        return startIndex + 1 + " - " + endIndex + " de " + length;
    };
    return customPaginatorIntl;
}
*/
